<script setup lang="ts">
// Without this, typescript thinks `LocaleSwitcher` is `SidebarLocaleSwitcher`
import { LocaleSwitcher as UILocaleSwitcher } from "#components"

const locales = useLocales()
</script>

<template>
  <UILocaleSwitcher :locales popover-side="top">
    <button
      data-testid="locale_switcher"
      class="group mb-2 flex w-full cursor-pointer items-center gap-3 rounded-lg p-2 transition-colors hover:bg-zinc-950/5 @[12rem]/navigation:mb-0"
    >
      <SvgoPikaTranslate
        class="size-5 text-zinc-500 group-hover:text-zinc-950"
      />
      <span
        class="hidden pr-4 text-base/6 font-medium text-zinc-950 sm:text-sm/5 @[12rem]/navigation:inline-block"
        >{{ $t("locale.current") }}</span
      >
    </button>
  </UILocaleSwitcher>
</template>
